export const FETCH_EVENT_START = 'FETCH_EVENT_START';
export const FETCH_EVENT_SUCCESS = 'FETCH_EVENT_SUCCESS';
export const FETCH_EVENT_FAIL = 'FETCH_EVENT_FAIL';

export const FETCH_CREATED_EVENTS_START = 'FETCH_CREATED_EVENTS_START';
export const FETCH_CREATED_EVENTS_SUCCESS = 'FETCH_CREATED_EVENTS_SUCCESS';
export const FETCH_CREATED_EVENTS_FAIL = 'FETCH_CREATED_EVENTS_FAIL';

export const FETCH_EVENTS_BY_SECTION_ID_START =
  'FETCH_EVENTS_BY_SECTION_ID_START';
export const FETCH_EVENTS_BY_SECTION_ID_SUCCESS =
  'FETCH_EVENTS_BY_SECTION_ID_SUCCESS';
export const FETCH_EVENTS_BY_SECTION_ID_FAIL =
  'FETCH_EVENTS_BY_SECTION_ID_FAIL';

export const CREATE_EVENT_START = 'CREATE_EVENT_START';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAIL = 'CREATE_EVENT_FAIL';
export const RESET_CREATE_EVENT_STORE = 'RESET_CREATE_EVENT_STORE';

export const UPDATE_EVENT_START = 'UPDATE_EVENT_START';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAIL = 'UPDATE_EVENT_FAIL';
export const RESET_UPDATE_EVENT_STORE = 'RESET_UPDATE_EVENT_STORE';

export const UPDATE_EVENT_TITLE_START = 'UPDATE_EVENT_TITLE_START';
export const UPDATE_EVENT_TITLE_SUCCESS = 'UPDATE_EVENT_TITLE_SUCCESS';
export const UPDATE_EVENT_TITLE_FAIL = 'UPDATE_EVENT_TITLE_FAIL';
export const RESET_UPDATE_EVENT_TITLE_STORE = 'RESET_UPDATE_EVENT_TITLE_STORE';

export const DELETE_EVENT_START = 'DELETE_EVENT_START';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAIL = 'DELETE_EVENT_FAIL';

export const RESET_EVENT_STORE = 'RESET_EVENT_STORE';

export type EventActionTypes =
  | typeof FETCH_EVENT_START
  | typeof FETCH_EVENT_SUCCESS
  | typeof FETCH_EVENT_FAIL
  | typeof FETCH_CREATED_EVENTS_START
  | typeof FETCH_CREATED_EVENTS_SUCCESS
  | typeof FETCH_CREATED_EVENTS_FAIL
  | typeof FETCH_EVENTS_BY_SECTION_ID_START
  | typeof FETCH_EVENTS_BY_SECTION_ID_SUCCESS
  | typeof FETCH_EVENTS_BY_SECTION_ID_FAIL
  | typeof CREATE_EVENT_START
  | typeof CREATE_EVENT_SUCCESS
  | typeof CREATE_EVENT_FAIL
  | typeof RESET_CREATE_EVENT_STORE
  | typeof UPDATE_EVENT_START
  | typeof UPDATE_EVENT_SUCCESS
  | typeof UPDATE_EVENT_FAIL
  | typeof RESET_UPDATE_EVENT_STORE
  | typeof UPDATE_EVENT_TITLE_START
  | typeof UPDATE_EVENT_TITLE_SUCCESS
  | typeof UPDATE_EVENT_TITLE_FAIL
  | typeof RESET_UPDATE_EVENT_TITLE_STORE
  | typeof DELETE_EVENT_START
  | typeof DELETE_EVENT_SUCCESS
  | typeof DELETE_EVENT_FAIL
  | typeof RESET_EVENT_STORE;
